import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';
import {
  ButtonGroup,
  Modal,
  ButtonToolbar,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import { List } from 'immutable';
import { injectIntl } from 'react-intl';
import Button from '../ui/Button';
import appConfig from '../../appConfig';
import { updateSortBy } from '../../actions/umoGallery';
import {
  showUMOGridView,
  showUMOGridNoJView,
  showUMOListView,
  showUMOSmGridNoJView,
  showUMOCarouselView,
  showUMOModifyDialog,
} from '../../actions/mainUI';
import { viewTypes } from '../../constants/umoGallery';
import { SearchParams } from '../../utils/searchUtils';
import { getLabelFromAppConfig, showUploadTemplate } from '../../utils/uiUtils';
import { validateSessionConnection } from '../../actions/session';
import { addError } from '../../actions/messageDialog';
import OptionsMenu from '../OptionsMenu';
import { UMO_MODIFY_TYPE_ZIP_DOWNLOAD } from '../../constants/umoModifications';
import FilterIcon from '../../../icons/sub-menu-and-common-icons/filter.svg';
import DownloadIcon from '../../../icons/sub-menu-and-common-icons/dowload.svg';
import GridView1 from '../../../icons/sub-menu-and-common-icons/tile-view1.svg';
import GridView2 from '../../../icons/sub-menu-and-common-icons/tile-view2.svg';
import GridView3 from '../../../icons/sub-menu-and-common-icons/tile-view3.svg';
import ListViewIcon from '../../../icons/sub-menu-and-common-icons/list-view.svg';
import PicViewIcon from '../../../icons/sub-menu-and-common-icons/pic-view.svg';
import languageIcon from '../../../icons/toolbar-icons/language.jpg';
import UploadBlack from '../Icons/UploadBlack';
import { isValidForFileUploader } from '../FilesUploader/utils';

const mapStateToProps = (state) => ({
  session: state.session,
  categories: state.categories,
  isLoading: state.umoGallery.get('isRequesting'),
  galleryType: state.umoGallery.get('galleryType'),
  selectedCategory: state.umoGallery.get('selectedCategory'),
  mainUI: state.mainUI,
});

const mapDispatchToProps = (dispatch) => ({
  sortByUpdate: (eventKey, isDesc) => dispatch(updateSortBy(eventKey, isDesc)),
  validateSession: (surl) => dispatch(validateSessionConnection(surl)),
  addError: (err) => dispatch(addError(err)),
  dispatchShowFileUploader: (categoryID, categoryName) =>
    showUploadTemplate(dispatch, categoryID, categoryName),
  dispatchErrorMessage: (message) => dispatch(addError(message)),
});


function UMOToolbar({
  isFilterExpanded,
  onFilterToggle,
  sortBy,
  sortByIsDescending,
  dispatch,
  filterByList,
  sortByUpdate,
  umoGalleryViewType,
  searchParams,
  selectedWorkspaceData = { id: null },
  selectedUMOIDs,
  isSelectAll,
  isUMOGalleryWorkspace,
  copyUMOs,
  intl,
  umoList,
  session,
  toggleCompareView,
  isLoading,
  languageList,
  changeDataLanguage,
  selectedLanguage,
  dispatchShowFileUploader,
  dispatchErrorMessage,
  mainUI,
  selectedCategory,
  galleryType,
  umoTotal,
  isMetaAttachView,
}) {
  const [sortPanelVisible, setSortPanelVisible] = useState(false);
  const [selectedSortValue, setSelectedSort] = useState(sortBy);
  const [selectedSortIsDesc, setSelectedSortIsDesc] = useState(sortByIsDescending);
  const [isValidForUploading, setIsValidForUploading] = useState(false);
  const isMaxDownloadItemsSelected =
    isSelectAll ? umoTotal > appConfig.advanced.maxDirectDownloadItems :
    selectedUMOIDs.size > appConfig.advanced.maxDirectDownloadItems;

  // Effect to check if file uploading is valid and set related states
  useEffect(() => {
    const isValid = isValidForFileUploader(
      searchParams,
      selectedCategory,
      galleryType
    );
    setIsValidForUploading(isValid);
  }, [searchParams, selectedCategory]);

  const changeViewType = (viewType) => {
    switch (viewType) {
      case viewTypes.LIST:
        dispatch(showUMOListView());
        break;
      case viewTypes.GRID_NOJ:
        dispatch(showUMOGridNoJView());
        break;
      case viewTypes.GRID:
        dispatch(showUMOGridView());
        break;
      case viewTypes.SM_GRID_NOJ:
        dispatch(showUMOSmGridNoJView());
        break;
      case viewTypes.CAROUSEL:
        dispatch(showUMOCarouselView());
        break;
      default:
        break;
    }
  };
  const onDownloadClick = () => {
    dispatch(
      showUMOModifyDialog(
        { modType: UMO_MODIFY_TYPE_ZIP_DOWNLOAD },
        selectedUMOIDs.size > 0 ? selectedUMOIDs.toJS() : null,
        searchParams,
        selectedWorkspaceData.id || selectedCategory?.get('i'),
      )
    );
  };

  const onUploadClick = () => {
    if (mainUI.getIn(['fileUploader', 'isUploading']))
      dispatchErrorMessage(
        intl.formatMessage({ id: 'fileUploader.uploadInProgressMessage' })
      );
    else
      dispatchShowFileUploader(
        selectedCategory.get('i'),
        selectedCategory.get('title') && selectedCategory.get('title') !== ''
        ? selectedCategory.get('title') : selectedCategory.get('n')
      );
  };

  let filterByCount = 0;

  if (filterByList) {
    filterByList.forEach((filterByItem) => {
      if (filterByItem.get('value')) {
        filterByCount += 1;
      }
    });
  }

  const sortModalOptions = appConfig.umoGallery.sortByOptions.map(
    (option, i) => (
      <li
        className="align-items-center d-flex justify-content-between"
        key={`${option}_${i}`}
      >
        <label>
          <input
            className="me-1 mb-1"
            type="radio"
            checked={option.value === selectedSortValue}
            onChange={() => {
              setSelectedSort(option.value);
              setSelectedSortIsDesc(false);
            }}
          />
          {getLabelFromAppConfig(option, intl.locale)}
        </label>
        <ButtonToolbar>
          <button
            className={cn(
              'me-1 mb-1 btn btn-sm umo-toolbar__sort-item',
              option.value === selectedSortValue && !selectedSortIsDesc
                ? 'btn-primary umo-toolbar__sort-item--selected text-light'
                : 'btn-outline-primary'
            )}
            onClick={() => {
              setSelectedSort(option.value);
              setSelectedSortIsDesc(false);
            }}
          >
            <i className="umo-toolbar__sort-item--up" />
          </button>
          <button
            className={cn(
              'me-1 mb-1 btn btn-sm umo-toolbar__sort-item',
              option.value === selectedSortValue && selectedSortIsDesc
                ? 'btn-primary umo-toolbar__sort-item--selected text-light'
                : 'btn-outline-primary'
            )}
            onClick={() => {
              setSelectedSort(option.value);
              setSelectedSortIsDesc(true);
            }}
          >
            <i className="umo-toolbar__sort-item--down" />
          </button>
        </ButtonToolbar>
      </li>
    )
  );
  const sortModal = (
    <Modal
      show={sortPanelVisible}
      onHide={() => {
        setSortPanelVisible(false);
        setSelectedSortIsDesc(sortByIsDescending);
        setSelectedSort(sortBy);
      }}
    >
      <Modal.Header closeButton className="umo-toolbar__sort-modal">
        <Modal.Title className="umo-gallery-header__lightbox-name">
          {intl.formatMessage({ id: 'searchResults.sortBy' })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="umo-toolbar__sort-modal-body">
        <ul>{sortModalOptions}</ul>
      </Modal.Body>
      <Modal.Footer className="umo-toolbar__sort-modal-footer">
        <Button
          variant="primary"
          onClick={() => {
            sortByUpdate(selectedSortValue, selectedSortIsDesc);
            setSortPanelVisible(false);
          }}
        >
          {intl.formatMessage({ id: 'umoModifyDialog.buttonApply' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );

  return (
    <div className="umo-gallery-header__umo-toolbar">
      <div className="umo-toolbar__sort-by">
        <ButtonGroup size="sm">
          <Button
            active={umoGalleryViewType === viewTypes.GRID}
            onClick={() => changeViewType(viewTypes.GRID)}
          >
            <img src={GridView1} className="umo-toolbar__icon" />
          </Button>
          <Button
            active={umoGalleryViewType === viewTypes.GRID_NOJ}
            onClick={() => changeViewType(viewTypes.GRID_NOJ)}
          >
            <img src={GridView2} className="umo-toolbar__icon" />
          </Button>
          <Button
            active={umoGalleryViewType === viewTypes.SM_GRID_NOJ}
            onClick={() => changeViewType(viewTypes.SM_GRID_NOJ)}
          >
            <div>
              <img src={GridView3} className="umo-toolbar__icon" />
            </div>
          </Button>
          <Button
            active={umoGalleryViewType === viewTypes.LIST}
            onClick={() => changeViewType(viewTypes.LIST)}
          >
            <img src={ListViewIcon} className="umo-toolbar__icon" />
          </Button>
          <Button
            active={umoGalleryViewType === viewTypes.CAROUSEL}
            onClick={() => changeViewType(viewTypes.CAROUSEL)}
          >
            <img src={PicViewIcon} className="umo-toolbar__icon" />
          </Button>
        </ButtonGroup>
      </div>
      <div className="umo-toolbar__sort">
        <Button
          size="sm"
          disabled={!umoList || umoList.size === 0}
          onClick={() => setSortPanelVisible(true)}
        >
          {intl.formatMessage({ id: 'searchResults.sortBy' })}
        </Button>
      </div>
      {session.get('acctType') === 'G' ? null : (
        <div className="umo-toolbar__options">
          <OptionsMenu
            dispatch={dispatch}
            searchParams={searchParams}
            selectedWorkspaceData={selectedWorkspaceData}
            selectedUMOIDs={selectedUMOIDs}
            isSelectAll={isSelectAll}
            isUMOGalleryWorkspace={isUMOGalleryWorkspace}
            className="font-xs-regular"
            title={intl.formatMessage({ id: 'searchResults.options' })}
            size="sm"
            id="umo-options-dropdown"
            umoList={umoList}
            disabled={!umoList || umoList.size === 0}
          />
        </div>
      )}
      <OverlayTrigger
        overlay={
          <Tooltip id="tooltip-disabled">
            {intl.formatMessage(
              { id: 'searchResults.download.tooManyItems' },
              { maxItems: appConfig.advanced.maxDirectDownloadItems }
            )}
          </Tooltip>
        }
        placement="bottom"
        trigger={isMaxDownloadItemsSelected ? ['hover', 'focus'] : []}
      >
        <div className="umo-toolbar__download">
          <Button
            size="sm"
            onClick={onDownloadClick}
            disabled={isMaxDownloadItemsSelected || (!isSelectAll && selectedUMOIDs.size === 0)}
          >
            <div>
              <img src={DownloadIcon} className="umo-toolbar__download-icon" />
            </div>
          </Button>
        </div>
      </OverlayTrigger>
      {appConfig.umoGallery.showCategoryUploadButton && isValidForUploading && (
        <div className="umo-toolbar__download">
          <Button size="sm" onClick={onUploadClick} disabled={isLoading}>
            <div>
              <UploadBlack />
            </div>
          </Button>
        </div>
      )}
      {appConfig.enableMultiLang && languageList && languageList.length > 1 ? (
        <Dropdown
          className="umo-toolbar__change-language-dropdown"
          onSelect={(langIndex) => {
            changeDataLanguage(languageList[langIndex]);
          }}
        >
          <Dropdown.Toggle
            variant="default"
            size="sm"
            id="dropdown-basic"
            className="umo-toolbar__change-language-button"
          >
            <img
              src={languageIcon}
              alt="LanguageChange"
              className="umo-toolbar__language-icon"
            />
            {selectedLanguage && selectedLanguage.$
              ? selectedLanguage.$.display
              : 'English'}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {languageList.map((lang, i) => (
              <Dropdown.Item key={lang._} value={lang._} eventKey={i}>
                {lang.$.display}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      ) : null}
      {appConfig.enableCopyUMOs &&
        (isSelectAll || selectedUMOIDs.size > 0) ? (
        <div className="umo-toolbar__options">
          <Button
            variant="default"
            size="sm"
            draggable
            onClick={() => copyUMOs(isUMOGalleryWorkspace)}
          >
            <div className="umo-toolbar__button umo-toolbar__outline-button">
              <i className="umo-toolbar__copy-icon" />
              &nbsp;
              {intl.formatMessage({ id: 'searchResults.copy' })}
            </div>
          </Button>
        </div>
      ) : null}
      {appConfig.umoGallery.filterByOptions && (
        <div className="umo-toolbar__filter">
          <Button
            onClick={() => onFilterToggle(!isFilterExpanded)}
            variant="default"
            size="sm"
            className={isFilterExpanded ? 'umo-toolbar__filter-active' : ''}
            disabled={isLoading}
          >
            <div className="umo-toolbar__button">
              <img src={FilterIcon} className="umo-toolbar__filter-icon" />
              &nbsp;
              {intl.formatMessage({ id: 'searchResults.filter' })}
              &nbsp;
              {filterByCount > 0 && (
                <label variant="primary">{filterByCount}</label>
              )}
            </div>
          </Button>
        </div>
      )}
      {!isMetaAttachView && appConfig.enableUmoCompare &&
      selectedUMOIDs.size > 1 &&
      selectedUMOIDs.size < 4 ? (
        <div className="umo-toolbar__options">
          <Button variant="default" size="sm" onClick={toggleCompareView}>
            <div>
              <i className="far fa-clone umo-toolbar__compare-icon" />
              &nbsp;
              {intl.formatMessage({ id: 'searchResults.compare' })}
            </div>
          </Button>
        </div>
      ) : null}
      {sortModal}
    </div>
  );
}

UMOToolbar.propTypes = {
  dispatch: PropTypes.func,
  sortByUpdate: PropTypes.func,
  sortBy: PropTypes.string,
  sortByIsDescending: PropTypes.bool,
  filterByList: PropTypes.instanceOf(Array),
  umoGalleryViewType: PropTypes.string,
  searchParams: PropTypes.instanceOf(SearchParams),
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  selectedUMOIDs: PropTypes.instanceOf(List),
  isSelectAll: PropTypes.bool,
  isUMOGalleryWorkspace: PropTypes.bool,
  copyUMOs: PropTypes.func,
  umoList: PropTypes.instanceOf(List),
  toggleCompareView: PropTypes.func,
  changeDataLanguage: PropTypes.func,
  selectedLanguage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  languageList: PropTypes.instanceOf(Array),
  umoTotal: PropTypes.number,
  isMetaAttachView: PropTypes.bool,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UMOToolbar)
);
